/* eslint-disable react/jsx-key */
import React from 'react';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { InquiryMessages } from './components/InquiryMessages';
import { InquiryReminders } from './components/InquiryReminders';
import { PreferredCurrency } from './components/PreferredCurrency';

export const RolexSettings = () => {
  return (
    <StandardLayoutV2
      title="Rolex Inquiry"
      classProps="flex-col-left"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent' }}
    >
      <InquiryMessages />
      <InquiryReminders />
      <div style={{ marginTop: 24 }}>
        <PreferredCurrency />
      </div>
    </StandardLayoutV2>
  );
};
